import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSortDisabled = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M11.2929 5.29289C11.6834 4.90237 12.3166 4.90237 12.7071 5.29289L15.7071 8.29289C15.9931 8.57889 16.0787 9.00901 15.9239 9.38268C15.7691 9.75636 15.4045 10 15 10H9C8.59554 10 8.2309 9.75636 8.07612 9.38268C7.92134 9.00901 8.00689 8.57889 8.29289 8.29289L11.2929 5.29289Z",
		fill: "#ACA7A7"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M11.2929 18.7071C11.6834 19.0976 12.3166 19.0976 12.7071 18.7071L15.7071 15.7071C15.9931 15.4211 16.0787 14.991 15.9239 14.6173C15.7691 14.2436 15.4045 14 15 14H9C8.59554 14 8.2309 14.2436 8.07612 14.6173C7.92134 14.991 8.00689 15.4211 8.29289 15.7071L11.2929 18.7071Z",
		fill: "#ACA7A7"
	})]
});
export default SvgSortDisabled;
